jQuery(document).ready(function($){
    function updateIcons() {
        $('.owl-prev').html('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><title>Left</title><polyline points="15 18 9 12 15 6"></polyline></svg>');
        $('.owl-next').html('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><title>Right</title><polyline points="9 18 15 12 9 6"></polyline></svg>');
    }

    // Observe new elements being added
    let observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if ($(mutation.target).find('.owl-prev, .owl-next').length) {
                updateIcons();
            }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Initial run
    updateIcons();


});



// fetch("https://ipapi.co/json/")
//   .then(response => response.json())
//   .then(data => {
//     var country = data.country_code;
//     //country = "SA";
//     var currentUrl = window.location.href;

//     // Prevent redirect if in an iframe (Shopify customizer/admin uses iframes)
//     if (window.top !== window.self) {
//       return;
//     }

//     // Detect current domain (supports live & preview URLs)
//     var origin = window.location.origin;

//     // Define URLs based on current domain
//     var arabicUrl = origin + "/ar";
//     var englishUrl = origin + "/";

//     // Avoid redirect loop
//     if (country === "SA" && !currentUrl.startsWith(arabicUrl)) {
//       window.location.href = arabicUrl;
//     } else if (country !== "SA" && currentUrl.startsWith(arabicUrl)) {
//       window.location.href = englishUrl;
//     }
//   });





  document.addEventListener("DOMContentLoaded", function () {
    // Try zoom (works in Chrome, Edge, Safari)
    document.body.style.zoom = "0.9";

    // Fallback for Firefox (using transform scale)
    if (navigator.userAgent.toLowerCase().includes("firefox")) {
      document.body.style.transform = "scale(0.9)";
      document.body.style.transformOrigin = "0 0";
      document.body.style.width = "111.11%";
    }
  });




